<template>
  <div>
    <div class="screen-title component mb-3">
      <span>{{ adminText('workflowsAll.categories_6ccb600', 'Categories') }}</span>
      <v-btn color="primary" icon small @click.prevent="isVisibleCreateCategoryDialog = true">
        <v-icon>add</v-icon>
      </v-btn>
    </div>
    <v-list class="transparent-list">
      <template v-for="(category, i) in categories">
        <v-list-tile :key="category.id" class="extend-height">
          <v-list-tile-content>
            <v-list-tile-title>
              <span :style="{ backgroundColor: category.color }" class="dot" />
              {{ workflowLabel(category.name) }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="!category.default">
            <v-btn icon @click="editCategory(category)">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider v-if="i + 1 < categories.length" :key="`divider-${i}-${category.id}`" />
      </template>
    </v-list>

    <div>
      <category-dialog
        :title="adminText('workflowsAll.new_category_f41ff0d', 'New category')"
        :show.sync="isVisibleCreateCategoryDialog"
        :event-id="id"
        :number-of-zones="numberOfZones"
        :submit-form="createCategory"
        :ok-text="adminText('workflowsAll.create_6e157c5', 'Create')"
      />
      <category-dialog
        :show.sync="isVisibleUpdateCategoryDialog"
        :event-id="id"
        :title="adminText('workflowsAll.update_category_54d466b', 'Update category')"
        :number-of-zones="numberOfZones"
        :initial-values="selectedCategory"
        :submit-form="updateCategory"
        :delete-category="deleteCategory"
        :ok-text="adminText('workflowsAll.update_fb91e24', 'Update')"
        @resetSelectedCategory="resetSelectedCategory"
      />
    </div>
    <errors-snackbar :open.sync="showError" :message="workflowLabel(Message)" color="primary" />
    <simple-snackbar :open.sync="showSuccess" :message-prop="workflowLabel(Message)" color="primary" />
  </div>
</template>
<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { CREATE_CATEGORY, UPDATE_CATEGORY, DELETE_CATEGORY } from './../../graphql/category.graphql'
import CategoryDialog from './category-dialog.vue'
import ErrorsSnackbar from '../shared/snackbars/errors-snackbar'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar'

export default {
  mixins: [WorkflowDisplay],
  name: 'categories',
  components: {
    CategoryDialog,
    ErrorsSnackbar,
    SimpleSnackbar,
  },
  props: {
    id: String,
    permission: String,
    categories: Array,
    numberOfZones: Number,
  },
  data() {
    return {
      selectedCategory: {},
      isVisibleCreateCategoryDialog: false,
      isVisibleUpdateCategoryDialog: false,
      showError: false,
      showSuccess: false,
      Message: '',
    }
  },
  methods: {
    editCategory(category) {
      this.selectedCategory = category
      this.isVisibleUpdateCategoryDialog = true
    },
    async createCategory(eventId, category) {
      await this.$apollo.mutate({
        mutation: CREATE_CATEGORY,
        variables: { eventId, category },
        refetchQueries: ['getEventCategories'],
      })
    },
    async updateCategory(eventId, formCategory) {
      const { id, default: defaultCategory, ...category } = formCategory

      return this.$apollo.mutate({
        mutation: UPDATE_CATEGORY,
        variables: { id, category, eventId },
        refetchQueries: ['getEventCategories'],
      })
    },
    async deleteCategory(eventId, id) {
      const response = await this.$apollo.mutate({
        mutation: DELETE_CATEGORY,
        variables: { eventId, id },
        refetchQueries: ['getEventCategories'],
      })
      if (response.errors) {
        this.showError = true

        return (this.Message = response.errors[0].message)
      }

      this.showSuccess = true
      this.Message = 'workflowsAll.delete_successful_49bdd4c'
    },
    resetSelectedCategory() {
      this.selectedCategory = {}
    },
  },
}
</script>

<style>
.extend-height > div {
  height: 56px;
}
</style>
